// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
// Common
import { findApplicationFromCode, namespace } from '../../enums/ItpRegex';
import ICONS from '@/common-utils/enums/icons';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
// Lang
import { nsContract } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.applicationCode
 * @param root0.itp
 * @param root0.posTerminalSerialNumber
 * @returns {JSX} RenderApplication
 */
function RenderApplication({ applicationCode, itp = null, posTerminalSerialNumber = null }) {

    // Constants
    const application = findApplicationFromCode(applicationCode);
    const applicationName = application?.name;

    // Fonctions
    const sendMail = () => {
        if (!application) {
            const mailContent = [
                `mailto:${process.env.CONTACT_UNKNOWN_ITP}?`,
                // eslint-disable-next-line max-len
                `subject=${getTranslatedText('mailto_unknown_application.subject', nsContract, { itp: itp || '', posTerminalSerialNumber: posTerminalSerialNumber || '' })}`,
                `&body=${getTranslatedText('mailto_unknown_application.object', nsContract)}`,
                `%0D%0A%0D%0A${getTranslatedText('mailto_unknown_application.object_line_two', nsContract)}`,
                `%0D%0A%0D%0A${getTranslatedText('mailto_unknown_application.signature', nsContract)}`
            ].join('');

            window.location.href = mailContent;
        }
    };

    return (
        <>
            {application &&
                <>
                    {!application.logo &&
                        // Application without logo
                        <div
                            title={applicationName}>
                            <Entity entity={application.entity} namespace={namespace} />
                        </div>
                    }
                    {application.logo &&
                        // RenderApplication with logo
                        <div className='flex flex-col items-center'>
                            <div className='max-w-20 max-h-10'>
                                <img alt=''
                                    src={application.logo}
                                    className='max-h-10 w-auto object-contain'
                                    title={applicationName} />
                            </div>
                            <small className='text-center whitespace-nowrap'
                                title={applicationName}>
                                <Entity entity={application.entity} namespace={namespace} />
                            </small>
                        </div>
                    }
                </>
            }
            {!application &&
                // No application found
                <div className='flex flex-col items-center'>
                    <TooltipHelper
                        asChild
                        trigger={
                            <button
                                type='button'
                                onClick={sendMail}
                                className='flex items-center bg-transparent border-none p-0 m-0 cursor-pointer focus:outline-none'
                            >
                                <Icon icon={ICONS.UNKNOWN} />
                                <Icon icon={ICONS.ARROW_RIGHT} />
                                <Icon icon={ICONS.CONTACT_MAIL} />
                            </button>
                        }
                        content={<Entity entity='tooltips.mail_to_unknown_application' namespace={nsContract} />}
                    />
                    <small>
                        <Entity entity='application.UNKNOWN_APPLICATION' namespace={namespace} />
                    </small>
                </div >
            }
        </>
    );
}

RenderApplication.propTypes = {
    applicationCode: PropTypes.string,
    shouldNotSendMail: PropTypes.bool,
    unknownApplicationMailContent: PropTypes.string
};


export default RenderApplication;